export enum ArtistsSortEnum {
    AllArtists = 0,
    PostProductionEngineers = 8,
    ProducersAndEngineers = 3,
    Musicians = 4,
    DjsOrProducers = 5,
    LiveSoundEngineers = 2
}